import React from 'react';
import { observer } from 'mobx-react';
import InactiveCard from '../../components/subscriptionCard/InactiveCard';
import useSubscriptionCard from '../../../store/models/subscriptions/useSubscriptionCard';

// Only reads `details` — connectedSchedules/availableSchedules aren't passed
// through to InactiveCard at all, by design (see InactiveCard.jsx).
const InactiveSubscriptionCardContainer = observer(function InactiveSubscriptionCardContainer({ subscription }) {
    const { details } = useSubscriptionCard(subscription.id);

    return (
        <InactiveCard
            publisher={details.publisher}
            app={details.app}
            timezone={details.timezone}
            lastSyncedLabel={details.lastSyncedLabel}
        />
    );
});

export default InactiveSubscriptionCardContainer;
